import React, { useEffect, useState } from 'react'
import { MultiSelect } from 'react-multi-select-component'
import SelectCloseIcon from '../../assets/select-close-icon.svg'
import ArrowDropDown from '../../assets/Content-Icons/dropdown'

// Made specifically for Multi select components with diffrent select value and diffrent selected tiles
const CustomMultiSelectValues = ({
  optionsData,
  selectedValue,
  onChange,
  dropDownlabelKey,
  tileLabelKey,
  valueKey = '_id',
}) => {
  const [options, setOptions] = useState([])
  const [multiSelectValue, setMultiSelectValue] = useState([])

  useEffect(() => {
    setOptions(
      optionsData.map((info) => ({
        dropDownlabel: info[dropDownlabelKey],
        tileLabel: info[tileLabelKey],
        value: info[valueKey],
      })),
    )
  }, [optionsData])

  useEffect(() => {
    setMultiSelectValue(
      selectedValue.map((info) => ({
        label: info[dropDownlabelKey],
        tileLabel: info[tileLabelKey],
        value: info[valueKey],
      })),
    )
  }, [selectedValue])

  const handleSetData = (selected) => {
    setMultiSelectValue(selected)
    let tempArr = []
    for (let index = 0; index < selected.length; index++) {
      const id = selected[index]?.value
      let tempObj = optionsData.find((obj) => obj[valueKey] === id)
      if (tempObj) {
        tempArr.push(tempObj)
      }
    }
    onChange(tempArr)
  }

  const valueRenderer = (selected) => {
    if (!selected.length) {
      return <p className="mt-3">Select...</p>
    }

    return selected.map((info) => (
      <button
        key={info.tileLabel}
        style={{
          borderRadius: '15px',
          backgroundColor: '#000',
          color: 'white',
          fontSize: '12px',
        }}
        className="mx-1 pl-2 pr-0 border-0 "
      >
        <div className=" d-flex justify-content-center align-items-center">
          {info.tileLabel}
          <img
            src={SelectCloseIcon}
            style={{ width: '14px', height: '14px' }}
            alt="SelectCloseIcon"
            className="mx-1 "
            onClick={() => handleSetData(selected.filter((ele) => ele.value !== info.value))}
          />
        </div>
      </button>
    ))
  }

  const DefaultItemRenderer = ({ checked, option, onClick, disabled }) => {
    console.log('option', option)
    return (
      <div
        className={`item-renderer ${disabled ? 'disabled' : ''} d-flex align-items-center `}
        style={{
          borderBottom:
            option.label === 'Select All' && option.value === '' ? '0.5px solid #707070' : '',
        }}
      >
        <input
          type="checkbox"
          onChange={onClick}
          checked={checked}
          tabIndex={-1}
          disabled={disabled}
          style={{ accentColor: '#000' }}
        />
        {option.label === 'Select All' && option.value === '' ? (
          <span style={{ fontSize: '15px' }}>{option.label}</span>
        ) : (
          <p className="mb-0" style={{ fontSize: '15px' }}>
            <span style={{ fontWeight: '500' }} className="mr-2">
              {option.tileLabel}
            </span>
            ({option.dropDownlabel})
          </p>
        )}
      </div>
    )
  }
  return (
    <MultiSelect
      options={options}
      valueRenderer={valueRenderer}
      ItemRenderer={DefaultItemRenderer}
      value={multiSelectValue}
      onChange={handleSetData}
      ArrowRenderer={ArrowDropDown}
    />
  )
}

export default CustomMultiSelectValues
